export const phoneQueryKeys = {
  calls: () => 'calls',
  serviceCompanies: () => 'serviceCompanies'
};
